import {TeamCacheProxy, UserCacheProxy} from "ng-cache";
import {PlayParticipantsConfig} from "../providers/PlayParticipantsConfig";
import {slice, forEach, isUndefined, chunk, find, filter, includes, orderBy} from "lodash";


export class ParticipantsListContainerController {
    public league: any;
    public sorting: any;
    public filtering: any;
    public participants: any[];
    public processedParticipants: any[];
    public loading: boolean;
    public data: any;

    public static $inject = ["$q", "TeamCacheProxy", "UserCacheProxy", "PlayParticipants"];
    constructor(
        private $q: angular.IQService,
        private TeamCacheProxy: TeamCacheProxy,
        private UserCacheProxy: UserCacheProxy,
        private PlayParticipants: PlayParticipantsConfig
    ) {

    }

    public $onChanges() {
        this.processedParticipants = this.participants;
        this.filterParticipants();
        this.sortParticipants();
    }

    /**
     * ~~SPLICER#MASTER~~
     */
    public splicerMaster(limit: number, offset: number) {
        const participantIds = [];
        const participants = slice(this.processedParticipants, offset, offset + limit);

        forEach(participants, (participant: any) => {
            if (isUndefined(participant.contestant)) {
                participantIds.push(participant.id);
            }
        });

        this.fetchParticipants(participantIds);

        return this.$q.when({
            offset: offset,
            total: this.processedParticipants ? this.processedParticipants.length : 0,
            data: participants
        });
    }

    /**
     * @param participantIds Ids of participants to map info to.
     */
    private fetchParticipants(participantIds: number[]) {
        const chunks = chunk(participantIds, this.PlayParticipants.requestSize);

        forEach(chunks, (ids: string[]) => {
            if (this.league.teamSize >= 2) {
                this.TeamCacheProxy.getTeams(ids, this.mapParticipantInfoToParticipants.bind(this));
            } else {
                this.UserCacheProxy.getUsers(ids, this.mapParticipantInfoToParticipants.bind(this));
            }
        });
    }

    /**
     * @param contestant
     */
    private mapParticipantInfoToParticipants(contestant: any) {
        let currentParticipant = find(this.processedParticipants, (participant: any) => {
            return participant.id === parseInt(contestant.getId(), 10);
        });

        if (currentParticipant) {
            currentParticipant.contestant = contestant;
        }
    }

    /**
     * Filter participants by provided filtering binding.
     */
    private filterParticipants() {
        const name = this.filtering.name;
        const statusFilter = this.filtering.statusFilter;
        let region = this.filtering.region;

        if (statusFilter) {
            this.processedParticipants = filter(this.processedParticipants, (participant: any) => {
                // After checkin has started, only show checkedIn. Else show checkedIn + signedUp.
                if (find(["checkIn", "inProgress", "finished"], s => s === this.league.state)) {
                    return participant.status === "checkedIn";
                } else {
                    return participant.status === "checkedIn" || participant.status === "signedUp";
                }
            });
        }

        if (name) {
            this.processedParticipants = filter(this.processedParticipants, (participant: any) => {
                return includes(participant.name.toLowerCase(), name.toLowerCase());
            });
        }

        if (region) {
            if (region === "null") {
                region = null;
            }

            this.processedParticipants = filter(this.processedParticipants, (participant: any) => {
                return participant.region === region;
            });
        }
    }

    /**
     * Sort participants by provided sorting binding.
     */
    private sortParticipants() {
        this.processedParticipants = orderBy(this.processedParticipants, [(processedParticipant: any) => {
            const property: any = processedParticipant[this.sorting.type];

            if (typeof property === "string") {
                return property.toLowerCase();
            }

            return property;
        }], [this.sorting.order]);

        // Split non-0-seeds & zero seeds.
        let nonZeroSeeds = [];
        let zeroSeeds = [];

        forEach(this.processedParticipants, (participant: any) => {
            if (participant.seed > 0) {
                nonZeroSeeds.push(participant);
            } else {
                zeroSeeds.push(participant);
            }
        });

        nonZeroSeeds.push(...zeroSeeds);
        this.processedParticipants = nonZeroSeeds;
    }

}